/* sts-library-suggest.js: suggestions under the Skincare Library search
   (prototype v6.2, handoff §8). Loaded by sections/sts-library-hub.liquid only.

   Typing opens up to 5 articles (16:9 thumbnail, title, topic and read time)
   and a last row, See all results for "...". Desktop: a list, thumbnail on
   the left. At 860px and under: cards that swipe sideways, thumbnail on top,
   with the shared scroll bar (assets/sts-scroll-ind.js). A suggestion opens
   its article; See all results runs the page's search (Enter and the Search
   button already do, in assets/sts-library.js). Escape, tapping outside or
   moving focus away closes the list.

   An ARIA 1.2 combobox: the field keeps focus, aria-expanded says whether the
   list is open, the arrows move aria-activedescendant through the options
   (See all results is the last one) and Enter opens the highlighted one.

   The matches are STS.library.search.hits(): the same list, and the same tag
   matches from sections/sts-library-suggest.liquid, the results use. */
(function (w, d) {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function boot() {
    var L = w.STS && w.STS.library;
    var api = L && L.search;
    var root = d.querySelector('[data-sts-lib-hub]');
    var input = root && root.querySelector('[data-sts-lib-q]');
    var box = input && input.parentNode;
    if (!api || !box || box.querySelector('.sts-lib-sugg')) return;

    var META = L.topicsMeta || {};
    var MUST = (L.config && L.config.mustKey) || '';
    var list = d.createElement('div');
    var live = d.createElement('span');
    var active = -1;
    var shown = null;
    var timer = null;

    list.id = 'sts-lib-sugg';
    list.className = 'sts-lib-sugg';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Search suggestions');
    list.hidden = true;
    live.className = 'sts-lib-visually-hidden';
    live.setAttribute('role', 'status');
    box.appendChild(list);
    box.appendChild(live);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');

    function options() { return list.querySelectorAll('[role="option"]'); }

    function highlight(i) {
      var o = options();
      if (o[active]) o[active].setAttribute('aria-selected', 'false');
      active = o[i] ? i : -1;
      if (active < 0) { input.removeAttribute('aria-activedescendant'); return; }
      o[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', o[i].id);
      try { o[i].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) { /* old engine */ }
    }

    function close() {
      highlight(-1);
      shown = null;
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    /* The article's topic: the first that is not Must Reads, as on the cards. */
    function topicOf(it) {
      for (var i = 0; i < it.topics.length; i++) if (it.topics[i] !== MUST) return it.topics[i];
      return it.topics[0] || '';
    }

    /* 16:9 at 96px (desktop) or 150px (phone card), 1x and 2x, off the
       image_url the feed carries. */
    function thumb(it) {
      if (!it.image) return '';
      var base = it.image.replace(/&width=\d+$/, '');
      var set = base === it.image ? '' : ' srcset="' + esc(base) + '&amp;width=192 192w, ' + esc(base) +
        '&amp;width=320 320w" sizes="(max-width: 860px) 150px, 96px"';
      return '<img src="' + esc(base === it.image ? it.image : base + '&width=192') + '"' + set +
        ' alt="" width="96" height="54" loading="lazy" decoding="async">';
    }

    function render() {
      var q = input.value.trim();
      if (!q || q === String(api.searched()).trim()) return close();
      var hits = api.hits(q, 5);
      var key = q + '|' + hits.map(function (h) { return h.handle; }).join(' ');
      if (key === shown) return;
      highlight(-1);
      shown = key;
      var html = '<div class="sts-lib-sugg__row" role="presentation" data-sts-scrollind-row>';
      for (var i = 0; i < hits.length; i++) {
        var it = hits[i];
        var t = topicOf(it);
        var m = META[t] || {};
        html += '<a class="sts-lib-sugg__opt" role="option" aria-selected="false" tabindex="-1" id="sts-lib-sugg-' + i +
          '" href="' + esc(it.url) + '"><span class="sts-lib-sugg__thumb" style="background:' + esc(m.color || '#DBE0EE') +
          '">' + thumb(it) + '</span><span class="sts-lib-sugg__text"><span class="sts-lib-sugg__t">' + esc(it.title) +
          '</span><span class="sts-lib-sugg__m">' + (t ? esc(L.labelOf(t)) + ' &middot; ' : '') + esc(it.read || 1) +
          ' min read</span></span></a>';
      }
      html += '</div>';
      if (!hits.length) html += '<p class="sts-lib-sugg__none">No matching articles yet</p>';
      html += '<button class="sts-lib-sugg__all" type="button" role="option" aria-selected="false" tabindex="-1" id="sts-lib-sugg-all">' +
        'See all results for &quot;' + esc(q) + '&quot;</button>';
      list.innerHTML = html;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      live.textContent = hits.length
        ? hits.length + (hits.length === 1 ? ' suggestion' : ' suggestions')
        : 'No matching articles yet';
    }

    function pick(el) {
      if (!el) return;
      if (el.tagName === 'A') { w.location.href = el.href; return; }
      close();
      api.run();
    }

    /* Local matches at once; the tag matches join when predictive search
       answers, and only redraw if they changed the list. */
    function suggest() {
      var q = input.value.trim();
      render();
      if (q.length > 1) api.tags(q).then(function () { if (input.value.trim() === q) render(); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(suggest, 120);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) suggest(); });
    input.addEventListener('keydown', function (ev) {
      var n = options().length;
      var k = ev.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        ev.preventDefault();
        if (list.hidden) { suggest(); return; }
        if (!n) return;
        highlight(k === 'ArrowDown' ? (active + 1) % n : (active < 1 ? n : active) - 1);
      } else if (k === 'Escape' && !list.hidden) {
        ev.preventDefault();
        close();
      } else if (k === 'Enter' && active > -1) {
        ev.preventDefault();
        pick(options()[active]);
      }
    });
    /* The field keeps focus while the list is pressed, so a click lands. A
       swipe fires no mousedown, so the cards still scroll. */
    list.addEventListener('mousedown', function (ev) { ev.preventDefault(); });
    list.addEventListener('click', function (ev) {
      var b = ev.target.closest && ev.target.closest('button[role="option"]');
      if (b) pick(b);
    });
    d.addEventListener('pointerdown', function (ev) {
      if (!list.hidden && !box.contains(ev.target)) close();
    }, true);
    d.addEventListener('focusin', function (ev) {
      if (!list.hidden && !box.contains(ev.target)) close();
    });
    root.addEventListener('sts:library:searched', close);
    root.addEventListener('sts:library:pool', function () { if (!list.hidden) render(); });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot);
  else boot();
}(window, document));
